import { render, staticRenderFns } from "./PageInfoProfessionnel.vue?vue&type=template&id=5d327249&scoped=true"
import script from "./PageInfoProfessionnel.vue?vue&type=script&lang=js"
export * from "./PageInfoProfessionnel.vue?vue&type=script&lang=js"
import style0 from "./PageInfoProfessionnel.vue?vue&type=style&index=0&id=5d327249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d327249",
  null
  
)

export default component.exports